import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const api = "https://apideneme.com.tr/api";

const UserItems = () => {
    const [items, setItems] = useState([]);
    const [userName, setUserName] = useState(""); // Kullanıcı adı için state
    const navigate = useNavigate();

    useEffect(() => {
        const userId = Cookies.get('user_id');
        if (!userId) {
            alert("Kullanıcı ID'si bulunamadı. Lütfen giriş yapın.");
            navigate('/');
        } else {
            getUserName(userId); // Kullanıcı adını al
            getUserItems(userId);
        }
    }, [navigate]);

    const getUserName = async (userId) => {
        try {
            const response = await axios.get(`${api}/users`, { params: { user_id: userId } });
            setUserName(response.data[0].name); // Kullanıcı adı verisini doğru şekilde al
        } catch (error) {
            console.error("Kullanıcı adını alırken hata oluştu:", error);
        }
    };

    const getUserItems = async (userId) => {
        try {
            const response = await axios.get(`${api}/items`, { params: { user_id: userId } });
            // Itemları id'ye göre sıralama
            const sortedItems = response.data.sort((a, b) => a.id - b.id);
            setItems(sortedItems);
        } catch (error) {
            console.error("Verileri alırken hata oluştu:", error);
        }
    };

    const deleteItem = async (id) => {
        const userId = localStorage.getItem('user_id');
        try {
            await axios.delete(`${api}/item/${id}`, { params: { user_id: userId } });
            getUserItems(userId);
        } catch (error) {
            console.error("Silme işlemi sırasında hata oluştu:", error);
            alert("Silme işlemi başarısız oldu. Lütfen tekrar deneyin.");
        }
    };

    const handleLogout = () => {
        Cookies.remove('user_token');
        Cookies.remove('user_id');
        localStorage.removeItem('user_id');
        navigate('/');
    };

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ flexGrow: 1, textAlign: "center", marginLeft: "93px" }}>
                    <Link to="/create" className="btn btn-success text-white mb-2 mt-2">Create</Link>
                </div>
                <div>
                    <button className="btn text-white mb-2 mt-2" style={{ backgroundColor: "#2af5aa", marginRight: "5px" }}>
                        {userName}
                    </button>
                    <button onClick={handleLogout} className="btn btn-danger" style={{ marginRight: "5px" }}>EXIT</button>
                </div>
            </div>

            <table className="table table-striped">
                <thead className="bg-success text-white">
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th>Image URL</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.name || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.description || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.price || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.image || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>
                                <Link to={`/edit/${item.id}`} className="btn btn-warning" style={{ marginRight: "1px" }}>Edit</Link>
                                <button onClick={() => deleteItem(item.id)} className="btn btn-danger">Delete</button>
                                <button
                                    onClick={() => {
                                        if (item.image) { 
                                            window.open(`http://127.0.0.1:8000/storage/${item.image}`, "_blank"); 
                                        }
                                    }}
                                    className="btn text-white"
                                    style={{ backgroundColor: "turquoise", marginLeft: "1px" }}
                                    disabled={!item.image}
                                >
                                    Open Image
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UserItems;
